import styled from 'styled-components';

export const ModalHeaderContainer = styled.div`
  .title-text {
    margin-bottom: 0;
  }
  .note-text {
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const CronBuilderContainer = styled.div`
  .cron_builder {
    max-width: 100%;
  }

  .mode-radio-wrapper {
    margin-bottom: 24px;
  }

  .header-text {
    font-size: 18px;
  }

  .title-text {
    font-weight: 500;
  }

  .flex {
    display: flex;
  }

  .error-text {
    color: red;
    font-size: 10px;
  }
`;

export const FrequencyBasedModeContainer = styled.div`
  .date-picker,
  .time-picker {
    width: 100%;
  }

  .frequency-inputs-wrapper {
    display: flex;
    gap: 12px;

    p {
      margin: 0;
    }
  }
`;
